import React, { useEffect, useState } from 'react'
import HeaderBarAdd from '../headerBarAdd'
import { Col, Form, Row, Typography, message } from 'antd'
import useDropdown from '../context/useDropdown'
import ButtonUC from '../../../components/buttonUC'
import SelectUC from '../../../components/Form/SelectUC'
import UploadForm from '../uploadForm'
import BtnEditUC from '../../../components/Form/BtnEditUC'
import BtnDeleteUC from '../../../components/Form/BtnDeleteUC'
import { MODE, filterIsDeleted } from '../constant'
import AutoCompleteUC from '../../../components/Form/AutoCompleteUC'
import CheckBoxUC from '../../../components/Form/CheckBoxUC'

const ProfesLicense = ({ props }) => {
    const {
        form,
        rcProfes,
        setRcProfes,
        rcDeletedData,
        setRcDeletedData,
        isReadOnly
    } = props
    const { Text } = Typography
    const { ddlProLicense, ddlProDept, getDDLLabel } = useDropdown()
    const [mode, setMode] = useState(MODE.VIEW) //view, edit
    const [tempAttachFile, setTempAttachFile] = useState(null)
    const [attachFileOriginal, setAttachFileOriginal] = useState(null)
    const [indexFile, setIndexFile] = useState(null)
    const [isReq, setReq] = useState(false)
    const isUnderExam = Form.useWatch('isUnderExam', form);

    useEffect(() => {
        setReq(mode === MODE.EDIT)
    }, [tempAttachFile, mode])

    const handleAdd = () => {
        // new
        let newRow = {
            sort: 1,
            proLicenseId: null,
            proDeptId: null,
        }

        if (rcProfes && rcProfes.length > 0) {
            const max = Math.max(...rcProfes.map(o => o.sort))
            newRow = {
                ...newRow,
                sort: max + 1,
            }
            setIndexFile(max + 1)
        }
        setForm(newRow)
        setMode(MODE.EDIT)
        setTempAttachFile(null)
    }

    const handleEdit = (record) => {
        if (record) {
            setForm(record)
            setMode(MODE.EDIT)
            // set attach file into upload form component
            if (rcProfes && rcProfes.length > 0) {
                let _attachFile = rcProfes.filter(item => item.sort === record.sort)[0].attachFile
                if (_attachFile) {
                    _attachFile.isCanNotDelete = true
                    setTempAttachFile(_attachFile)
                    setAttachFileOriginal(_attachFile)
                }
            }
            setIndexFile(record.sort)
        }
    }

    const setForm = (record) => {
        form.setFieldsValue({
            profes_sort: record.sort,
            profes_proLicenseId: record.id ? (record.proLicenseName ?? record.proLicenseId) : record.proLicenseId,
            profes_proDeptId: record.id ? (record.proDeptName ?? record.proDeptId) : record.proDeptId,
            isUnderExam: record.isUnderExam
        })
    }

    const handleCancel = () => {
        const row = rcProfes.filter(item => item.sort === indexFile)
        if (row && row.length > 0 && !isUnderExam) {
            setRcProfes(rcProfes.map((obj) => obj.sort === indexFile ? { ...obj, attachFile: attachFileOriginal } : obj))
        }
        setMode(MODE.VIEW)
    }

    const handleSubmit = () => {
        const dataPreSubmit = {
            sort: form.getFieldValue('profes_sort'),
            proLicenseId: form.getFieldValue('profes_proLicenseId'),
            proLicenseName: form.getFieldValue('profes_proLicenseId'),
            proDeptId: form.getFieldValue('profes_proDeptId'),
            proDeptName: form.getFieldValue('profes_proDeptId'),
            isUnderExam: form.getFieldValue('isUnderExam'),
        }

        const dataColValidate = [
            { caption: "กรุณาเลือกใบประกอบวิชาชีพ", columnName: "profes_proLicenseId" },
            { caption: "กรุณาเลือกหน่วยงานที่ออกใบประกอบวิชาชีพ", columnName: "profes_proDeptId" },
        ]
        let isValidate = false
        dataColValidate.forEach(el => {
            const _isValidate = checvalidateDraft(el)
            isValidate = isValidate ? isValidate : (_isValidate ?? false)
        })
        // ไฟล์แนบ
        if ((tempAttachFile && !isValidate) || (isUnderExam && !isValidate)) {
            if (dataPreSubmit.attachFile && dataPreSubmit.attachFile.id) {
                setRcDeletedData([...rcDeletedData, { id: dataPreSubmit.attachFile.id, tableName: 'rcAttachFileProLicense', filePath: dataPreSubmit.attachFile.filePath }])
            }
            dataPreSubmit.attachFile = tempAttachFile;
        } else {
            if (isValidate) {
                message.warning('กรุณากรอกข้อมูลใบประกอบวิชาชีพ');
            } else {
                message.warning('กรุณาเลือกไฟล์แนบ');
            }
            return false
        }

        const row = rcProfes.filter(item => item.sort === dataPreSubmit.sort)
        if (row && row.length > 0) {
            setRcProfes(rcProfes.map((obj) => obj.sort === dataPreSubmit.sort ? { ...obj, ...dataPreSubmit } : obj))
        } else {
            setRcProfes([...rcProfes, dataPreSubmit])
        }
        // เคลียร์ไฟล์แนบออกกรณี บางแถวไม่มีไฟล์แนบจะนำไฟล์ที่ค้างมาใส่แทน
        setTempAttachFile(null)
        setMode(MODE.VIEW)
    }

    const checvalidateDraft = (e) => {
        const _data = form.getFieldValue([e.columnName])
        if (!_data || _data === '') {
            form.setFields([
                {
                    name: [e.columnName],
                    errors: [e.caption],
                },
            ]);
            return true
        }
        return false
    }

    const handleDelete = (record) => {
        if (record.id) {
            // เก็บ Record ที่ลบ
            const recordDel = [{ id: record.id, tableName: 'appProfileProLicense' }]
            // ลบไฟล์แนบ
            if (record.attachFile) {
                recordDel.push({ id: record.attachFile.id, tableName: 'rcAttachFileProLicense', filePath: record.attachFile.filePath })
            }
            setRcDeletedData([...rcDeletedData, ...recordDel])
        }
        setRcProfes(rcProfes.filter(r => r.sort !== record.sort))
    }

    const handleUpload = (file) => {
        const _sort = form.getFieldValue('profes_sort')
        const _attachFile = {
            ...file,
            sort: _sort,
        }
        setTempAttachFile(_attachFile) //สำหรับแสดงใน edit form
    }

    const handleDeleteAttachFile = (data) => {
        const _sort = (data?.sort ? data.sort : indexFile)
        const fileDelete = rcProfes.filter(item => item.sort === _sort)
        if (fileDelete && fileDelete.length > 0 && fileDelete[0].attachFile) {
            setRcDeletedData([...rcDeletedData, { id: fileDelete[0].attachFile.id, tableName: 'rcAttachFileProLicense', filePath: fileDelete[0].attachFile.filePath }])
            fileDelete[0].attachFile = null
            setTempAttachFile(null)
        } else {
            setTempAttachFile(null)
        }
    }

    const setFormEdit = (e) => {
        let profes_proLicense = null, profes_proDept = null
        if (ddlProLicense.filter(filterIsDeleted)?.length > 0) {
            profes_proLicense = ddlProLicense.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('profes_proLicenseId'))
        }
        if (ddlProDept.filter(filterIsDeleted)?.length > 0) {
            profes_proDept = ddlProDept.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('profes_proDeptId'))
        }

        form.setFieldsValue({
            profes_proLicenseId: profes_proLicense ? profes_proLicense.value : form.getFieldValue('profes_proLicenseId'),
            profes_proDeptId: profes_proDept ? profes_proDept.value : form.getFieldValue('profes_proDeptId'),
            isUnderExam: isUnderExam ? isUnderExam : form.getFieldValue('isUnderExam')
        })
    }

    const FormView = ({ data }) => {
        // const _proLicense = getDDLLabel(ddlProLicense, data.proLicenseId)
        const _proLicense = data.id ? (ddlProLicense?.find(e => e.id === data.proLicenseId)?.value ?? data.proLicenseName) : data.proLicenseId
        let _attachFile = null
        if (rcProfes && rcProfes.length > 0) {
            const att = rcProfes.filter(item => item.sort === data.sort)
            if (att && att.length > 0 && att[0].attachFile) {
                _attachFile = att[0].attachFile
                _attachFile.isCanNotDelete = false
            }
        }
        return (
            <>
                <Row className="py-2 p-3">
                    <Col xs={24} md={20} className='px-2 flex items-center'>
                        <Text className='text-pro-license color-secondary1'>{_proLicense}</Text>
                    </Col>
                    <Col xs={24} md={4} className='px-2'>
                        <div className="flex justify-end">
                            <BtnEditUC disabled={data.isCanNotEdit === true || isReadOnly} handleEdit={() => handleEdit(data)} />
                            <BtnDeleteUC disabled={data.isCanNotDelete === true || isReadOnly} handleDelete={() => handleDelete(data)} />
                        </div>
                    </Col>
                </Row>
                {data.attachFile ?
                    <Row className="p-2">
                        <UploadForm
                            handleUpload={handleUpload}
                            handleDelete={() => {
                                handleDeleteAttachFile(data)
                            }}
                            attachFile={_attachFile} />
                    </Row> : null
                }
            </>
        )
    }

    const setUnderExam = (data) => {
        if (data?.target?.checked) {
            handleDeleteAttachFile()
        } else {
            const _sort = (data?.sort ? data.sort : indexFile)
            const fileDelete = rcProfes.filter(item => item.sort === _sort)
            if (fileDelete && fileDelete.length > 0 && !fileDelete[0].attachFile) {
                setTempAttachFile(null)
            }
        }
    }

    const FormEdit = (data) => {
        setFormEdit()
        return (
            <>
                <Row>
                    <Col>
                        <CheckBoxUC isShowHead={false}
                            label='อยู่ระหว่างการสอบ'
                            name={'isUnderExam'}
                            onChange={setUnderExam}
                        />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={0} className={'hidden'}>
                        <Text name={'profes_sort'}></Text>
                    </Col>
                    <Col xs={24} md={16} className='px-2'>
                        <AutoCompleteUC
                            maxLength={100}
                            required={isReq}
                            label='ใบประกอบวิชาชีพ'
                            name={'profes_proLicenseId'}
                            options={ddlProLicense.filter(filterIsDeleted)} />
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <AutoCompleteUC
                            maxLength={100}
                            required={isReq}
                            label='หน่วยงานที่ออกใบประกอบวิชาชีพ'
                            name={'profes_proDeptId'}
                            options={ddlProDept.filter(filterIsDeleted)} />
                    </Col>
                </Row>
                {!isUnderExam ?
                    <Row className="p-2">
                        <UploadForm
                            handleUpload={handleUpload}
                            attachFile={tempAttachFile}
                            handleDelete={(e) => {
                                handleDeleteAttachFile(e)
                            }} />
                    </Row> : null}

                <Row className="py-2">
                    <Col span={24} className='px-2 flex justify-end'>
                        <ButtonUC className='btn-clear mr-3' onClick={() => handleCancel()}>ยกเลิก</ButtonUC>
                        <ButtonUC className='btn-custom ml-3' onClick={() => handleSubmit()}>บันทึก</ButtonUC>
                    </Col>
                </Row>
            </>
        )
    }
    return (
        <div className='div-profes w-full mt-6'>
            <HeaderBarAdd title={'ใบประกอบวิชาชีพ'} handleAdd={handleAdd} disabled={mode === 'edit' || isReadOnly} />
            {mode === 'view' && rcProfes && rcProfes.length > 0 ?
                <>
                    {rcProfes.map((item, index) => {
                        return (
                            <FormView key={index} data={item} />
                        )
                    })}
                </>
                : <>{mode === 'edit' && <FormEdit />}</>}
        </div>
    )
}

export default ProfesLicense